import {
  Text,
  VStack,
  Box,
  Divider,
  HStack,
  Image,
  Center,
} from '@chakra-ui/react';

import { taskStatusMapper } from '../utils';
import { extractName, transformDate } from '../../../utils';
import { TaskStatusBadge } from '.';

export const TaskDetailHeader = ({
  userPreferenceData,
}: {
  userPreferenceData?: {
    id?: number;
    formTemplateId?: number;
    tempFormId?: number;
    field: string;
  }[];
}) => {
  return (
    (
      <HStack
        display="flex"
        flexDirection="row"
        minWidth="max-content" // Ensure the content respects its width
      >
        <HStack
          position="sticky"
          left="0" // Sticks to the left during scroll
          zIndex="10" // Ensures it stays above other elements
          height="60px"
          background="white"
        >
          <HStack
            height="60px"
            borderRadius="8px"
            background="#F5F5F5"
          >
          <VStack w="250px" align="center" gap="0">
            <Text fontSize="md">
              <Box as="span" color="#000">
                Status
              </Box>
            </Text>
          </VStack>
          </HStack>
        </HStack>
     <HStack
       style={{height: "60px",borderRadius:"8px", marginLeft: "16px", marginRight: "16px"}}
       px="2"
       py="2"
       borderRadius="8px"
       background="#F5F5F5"
     >
       <VStack w="250px" maxW="250px" align="start" gap="0">
         <Text fontSize="md">
           <Box as="span" color="#000" mx={"16px"}>
             Form Name
           </Box>
         </Text>
       </VStack>
       <VStack w="200px" maxW="200px"  align="start" gap="0">
         <Text fontSize="md">
           <Box as="span" color="#000" >
             Workflow Name
           </Box>
         </Text>
       </VStack>
       <VStack w="200px" maxW="200px" align="start" gap="0">
         <Text fontSize="md">
           <Box as="span" color="#000">
             Project Name
           </Box>
         </Text>
       </VStack>

       <VStack w="250px" maxW="250px" align="start" gap="0">
         <Text fontSize="md">
           <Box as="span" color="#000">
             Received From
           </Box>
         </Text>
       </VStack>
       <VStack w="250px" maxW="250px" align="start" gap="0">
         <Text fontSize="md">
           <Box as="span" color="#000">
             Received At
           </Box>
         </Text>
       </VStack>

       {userPreferenceData?.map(customCol => (
         <VStack key={customCol.id} w="200px" maxW="200px" align="start" gap="0">
           <Text fontSize="md">
             <Box as="span" color="#000">
               {customCol.field}
             </Box>
           </Text>
         </VStack>
       ))}
     </HStack>
     </HStack>
  ));
};
